export class OrganizationKey {
  constructor(
    private readonly id: number,
    private readonly shortDescription: string,
    private readonly information: string[] | null,
    private readonly reportKeysCount: number
  ) {}

  getId() {
    return this.id;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getInformation() {
    return this.information;
  }

  getMatchedKeysCount() {
    return this.reportKeysCount;
  }
}
